import { all, call, put, takeLatest } from 'redux-saga/effects';
import handleError from '@/adapters/httpErrors';
import attachmentsProvider from '@/lib/attachments';
import { PageDTO } from '@/dtos/generics';
import AttachmentsDTO from '@/dtos/attachments/AttachmentsDTO';
import AttachmentsActions, { AttachmentsTypes } from './duck';
import { toast } from 'react-toastify';

type ListParams = ReturnType<typeof AttachmentsActions.listRequest>;

export function* list({ payload }: ListParams): Generator {
  try {
    const { filters } = payload;
    const result = (yield call(
      [attachmentsProvider, attachmentsProvider.list],
      filters
    )) as unknown as AttachmentsDTO[];

    const pageResult: PageDTO<AttachmentsDTO> = {
      data: result,
      total: result.length,
      prev: undefined,
      next: undefined,
      currentPage: 1,
    };

    yield put(AttachmentsActions.listSuccess(pageResult));
  } catch (err) {
    const error = handleError(err);
    yield put(AttachmentsActions.listError(error));
  }
}

type CreateParams = ReturnType<typeof AttachmentsActions.createRequest>;

export function* create({ payload }: CreateParams): Generator {
  try {
    const data = (yield call(
      [attachmentsProvider, attachmentsProvider.create],
      payload
    )) as AttachmentsDTO;
    yield put(AttachmentsActions.createSuccess(data));
    toast.success('Anexo criado com sucesso!');
    return data;
  } catch (err) {
    const error = handleError(err);
    yield put(AttachmentsActions.createError(error));
    return null;
  }
}

type DeleteParams = ReturnType<typeof AttachmentsActions.deleteRequest>;

export function* deleteAttachment({ payload }: DeleteParams): Generator {
  try {
    const id = payload;
    yield call([attachmentsProvider, attachmentsProvider.delete], id);
    yield put(AttachmentsActions.deleteSuccess(id));
    toast.success('Anexo excluído com sucesso!');
  } catch (err) {
    const error = handleError(err);
    yield put(AttachmentsActions.deleteError(error));
  }
}

type DownloadParams = ReturnType<typeof AttachmentsActions.downloadRequest>;

export function* downloadAttachment({ payload }: DownloadParams): Generator {
  try {
    const { id, filename } = payload;
    yield call([attachmentsProvider, attachmentsProvider.download], id, filename);
    yield put(AttachmentsActions.downloadSuccess());
    toast.success('Download iniciado!');
  } catch (err) {
    const error = handleError(err);
    yield put(AttachmentsActions.downloadError(error));
  }
}

export default all([
  takeLatest(AttachmentsTypes.LIST_REQUEST, list),
  takeLatest(AttachmentsTypes.CREATE_REQUEST, create),
  takeLatest(AttachmentsTypes.DELETE_REQUEST, deleteAttachment),
  takeLatest(AttachmentsTypes.DOWNLOAD_REQUEST, downloadAttachment),
])
